import Api from '../services/api.js'
import history from '../history'

export function fetchAppTokenRequest(){
  return {
    type: 'FETCH_APP_TOKEN_REQUEST'
  }
}

export function fetchAppTokenSuccess(body){
  return {
    type: 'FETCH_APP_TOKEN_SUCCESS',
    body: body
  }
}

export function fetchAppTokenFailure(exception){
  return {
    type: 'FETCH_APP_TOKEN_FAILURE',
    exception: exception
  }
}

export function clearAppToken() {
  return {
    type: 'CLEAR_APP_TOKEN'
  }
}

export function loggedAsManager(is_manager) {
  return {
    type: 'LOGIN_AS_MANAGER',
    body: is_manager,
  }
}

export function fetchAppToken(credentials) {
  credentials['grant_type'] = "password";
  return dispatch => {
    dispatch(fetchAppTokenRequest())
    const api = new Api();
    return api.post("/oauth/token", credentials)
    .then(response => {
      Promise.all([
        dispatch(fetchAppTokenSuccess(response.data))
      ]).then(() => {
        dispatch(logInWithToken(response.data.access_token))
      });
    })
    .catch(err => dispatch(fetchAppTokenFailure(err)));
  }
}

export function logInWithToken(token) {
  return dispatch => {
    const api = new Api();
    return api.login("/api/v1/me", token)
    .then(response => {
      if (response.status === 200){
        dispatch(loggedAsManager(response.data.is_manager))

        history.push("/home")
      }
    })
    .catch(err => {
      //this will clear the state
      dispatch(clearAppToken())
      history.push("/")
    });
  }
}

export function logOutToken(token) {
  return dispatch => {
    const api = new Api();
    return api.logout("/oauth/revoke", {token: token})
    .then(response => {
      if (response.status === 200){
        //try to log-in again using the same token
        dispatch(logInWithToken(token))
      }
    })
    .catch(err => {});
  }
}



// WEBPACK FOOTER //
// ./src/actions/app_token.js